<template>
	<div class="flex w-full h-full">
		<!-- <div style=" background: white; height: 100%; position: absolute; width: 100%; opacity: 0.6; z-index: 9;">
      <ul class="loader">
        <li class="dot-a"></li>
        <li class="dot-b"></li>
        <li class="dot-c"></li>
        <li class="dot-d"></li>
        <li class="dot-e"></li>
        <li class="dot-f"></li>
        <li class="dot-g"></li>
        <li class="dot-h"></li>
        <li class="dot-i"></li>
      </ul>
    </div> -->
		<!-- <div class="flex h-full w-full align-content-center justify-content-center"> -->
		<div class="container align-content-center justify-content-center">
			<b v-if="props.title" class="text-center">{{ props.title }}</b>
			<video
				v-if="usarAguia"
				class="gif"
				autoplay
				loop
				muted
				playsinline
			>
				<source src="../assets/aguia-loader.webm" type="video/webm">
			</video>
			<img v-else src="../assets/output-onlinegiftools.gif" class="gif" alt="Carregando">
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { onMounted, ref } from "vue";

	const props = withDefaults(defineProps<{
		title?: string
	}>(), {
		title: ''
	});

	/** Alterna a mídia do carregamento a cada montagem do componente. */
	const usarAguia = ref(false);

	onMounted(() => {
		usarAguia.value = Math.random() >= 0.5;
	});

</script>

<style scoped>
	.container {
		width: 100%;
		height: 100%;
	}

	.gif {
		width: 50%;
		margin-left: auto;
		margin-right: auto;
		margin-top: auto;
		margin-bottom: auto;
		display: block;
	}
</style>


<!-- .container {
width: 100%;
/* ou a largura desejada */
height: 100%;
/* altura desejada */
overflow: hidden;
/* Esconde a parte do GIF que excede a div */
}

.gif {
width: 100%;
/* Faz o GIF ocupar toda a largura da div */
/* height: auto; */
/* Mantém a proporção do GIF */
display: block;
/* Remove espaços em branco abaixo da imagem */
} -->
